import Reveal from "../../components/ui/Reveal";
import ObjectiveCard from "./ObjectiveCard";
import { OBJECTIVES } from "../../constants/data";
import { fonts } from "../../constants/theme";

export default function Objetivos() {
  return (
    <section
      id="objetivos"
      style={{
        padding: "4.5rem 16px 5.5rem",
        background: "#f8fafc",
        position: "relative",
        overflow: "hidden"
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          #objetivos {
            padding: 3rem 12px 4rem !important;
          }
          .obj-header-box {
            margin-bottom: 2.2rem !important;
          }
          .obj-grid {
            gap: 14px !important;
            padding: 0 !important;
          }
          .obj-card-item {
            margin-top: 0 !important;
            padding: 1.4rem 1.1rem !important;
            border-radius: 18px !important;
          }
        }
      `}</style>

      <Reveal>
        <div className="obj-header-box" style={{ textAlign: "center", marginBottom: "3.5rem" }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: ".5rem",
            fontFamily: fonts.body, fontSize: ".72rem", fontWeight: 800,
            letterSpacing: ".14em", textTransform: "uppercase", color: "#157a35",
            marginBottom: ".8rem",
            background: "#ecfdf5",
            border: "1.5px solid #a7f3d0",
            padding: ".35rem 1rem",
            borderRadius: 9999,
            boxShadow: "0 2px 8px rgba(46, 125, 50, 0.08)"
          }}>
            Transformación Saludable
          </div>
          <h2 style={{ fontFamily: fonts.display, fontSize: "clamp(2rem, 4.5vw, 3.2rem)", fontWeight: 900, color: "#06241a", letterSpacing: "-0.025em" }}>
            Nuestros <span style={{ color: "#10b981" }}>Objetivos Clave</span>
          </h2>
          <p style={{ fontFamily: fonts.body, fontSize: "clamp(0.92rem, 1.8vw, 1.05rem)", color: "#52695c", maxWidth: 580, margin: "0.6rem auto 0", lineHeight: 1.6 }}>
            Tecnología, nutrición y bienestar en perfecta armonía para que alcances tu mejor versión.
          </p>
        </div>
      </Reveal>

      <div className="obj-grid" style={{ width: "min(1320px, 100%)", margin: "0 auto" }}>
        {OBJECTIVES.map((obj, i) => (
          <Reveal key={obj.title} delay={i * 0.06}>
            <ObjectiveCard {...obj} offset={false} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
